import ResponsiveContentWrapper from "../components/layout/ResponsiveContentWrapper";
import PermissionManagement from "../components/permissionManagement/PermissionManagement";

const PermissionManagementPage = () => (
  <ResponsiveContentWrapper>
    <PermissionManagement />
  </ResponsiveContentWrapper>
);

export default PermissionManagementPage;
